export const APP_NAME = 'Gustav';
